import {
  createFileRoute,
  useLocation,
  useNavigate,
  useRouterState,
} from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/_fallback_route/')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  const location = useLocation()
  const { status } = useRouterState()

  useEffect(() => {
    // Avoid interfering while the router is transitioning
    if (status !== 'idle') return

    // Skip redirect during OAuth callbacks
    const params = new URLSearchParams(window.location.search)
    const isAuthCallback =
      params.has('code') ||
      params.has('state') ||
      params.has('error') ||
      params.has('session_state')

    if (isAuthCallback) return

    navigate({ to: '/landing' })
  }, [status, location.search, navigate])

  return null
}
